import Main from './components/list/Main.vue'
import Tranfer from './components/list/Transfer.vue'
import Create from './components/list/Create.vue'
import Show from './components/show/Main.vue'
import Edit from './components/show/profile/Edit.vue'

import Sold from './components/show/Sold.vue'
import Cancel from './components/show/Lost.vue'

import Attachments from './components/show/attachments/Main.vue'
import UploadAttachment from './components/show/attachments/Upload.vue'

import Emails from './components/show/emails/Main.vue'
import EmailShow from '@/modules/emails/components/Show.vue'
import SendEmail from './components/show/emails/Form.vue'

import FollowUps from './components/show/follow_ups/Main.vue'

import Quotations from './components/show/quotations/Main.vue'
import SendQuotation from './components/show/quotations/Send.vue'
import AddQuotation from './components/show/quotations/Add.vue'
import EditQuotation from './components/show/quotations/edit/Main.vue'

import InfoQuotation from './components/show/quotations/edit/Info.vue'
import ProductsQuotation from './components/show/quotations/edit/products/Main.vue'
import ChargesQuotation from './components/show/quotations/edit/charges/Main.vue'
import AdditionalQuotation from './components/show/quotations/edit/AdditionalInfo.vue'
import PaymentQuotation from './components/show/quotations/edit/payments/Main.vue'

import Tasks from './components/show/tasks/Main.vue'
import TaskForm from './components/show/tasks/Form.vue'

export default [
    {
        name: 'deals.index',
        path: '/deals',
        component: Main,
        meta: { requiresAuth: true }
    },
    {
        name: 'deals.transfer',
        path: '/deals/transfer',
        components: { modal: Tranfer },
        meta: {
            requiresAuth: true,
            isAdminRoute: true
        }
    },
    {
        name: 'deals.create',
        path: '/deals/create',
        components: { modal: Create },
        meta: { requiresAuth: true }
    },
    {
        name: 'deals.show.sold',
        path: '/deals/:id/sold',
        components: {
            default: Show,
            modal: Sold
        },
        meta: { requiresAuth: true }
    },
    {
        name: 'deals.show.cancel',
        path: '/deals/:id/cancel',
        components: {
            default: Show,
            modal: Cancel
        },
        meta: { requiresAuth: true }
    },
    {
        name: 'deals.show',
        path: '/deals/:id',
        redirect: '/deals/:id/follow-ups',
        component: Show,
        meta: { requiresAuth: true },
        children: [
            {
                name: 'deals.show.follow-ups',
                path: '/deals/:id/follow-ups',
                component: FollowUps,
                meta: { requiresAuth: true }
            },
            {
                name: 'deals.show.quotations',
                path: '/deals/:id/quotations',
                component: Quotations,
                meta: { requiresAuth: true }
            },
            {
                name: 'deals.show.quotations.send',
                path: '/deals/:id/quotations/:quotation/send',
                component: SendQuotation,
                meta: { requiresAuth: true }
            },
            {
                name: 'deals.show.tasks',
                path: '/deals/:id/tasks',
                component: Tasks,
                meta: { requiresAuth: true },
                children: [
                    {
                        name: 'deals.show.tasks.create',
                        path: '/deals/:id/tasks/create',
                        component: TaskForm,
                        meta: { requiresAuth: true }
                    },
                    {
                        name: 'deals.show.tasks.edit',
                        path: '/deals/:id/tasks/:task/edit',
                        component: TaskForm,
                        meta: { requiresAuth: true }
                    }
                ]
            },
            {
                name: 'deals.show.emails',
                path: '/deals/:id/emails',
                component: Emails,
                meta: { requiresAuth: true },
                children: [
                    {
                        name: 'deals.show.emails.create',
                        path: '/deals/:id/emails/create',
                        component: SendEmail,
                        meta: { requiresAuth: true }
                    },
                    {
                        name: 'deals.show.emails.edit',
                        path: '/deals/:id/emails/:email/edit',
                        component: SendEmail,
                        meta: { requiresAuth: true }
                    }
                ]
            },
            {
                name: 'deals.show.attachments',
                path: '/deals/:id/attachments',
                component: Attachments,
                meta: { requiresAuth: true }
            },
            {
                name: 'deals.show.attachments.create',
                path: '/deals/:id/attachments/create',
                components: UploadAttachment,
                meta: { requiresAuth: true }
            }
        ]
    },
    {
        name: 'deals.edit',
        path: '/deals/:id/edit',
        components: {
            default: Show,
            modal: Edit
        },
        meta: { requiresAuth: true }
    },
    {
        name: 'deals.show.quotations.create',
        path: '/deals/:id/quotations/create',
        components: {
            default: Show,
            modal: AddQuotation
        },
        meta: { requiresAuth: true }
    },
    {
        name: 'deals.show.quotations.edit',
        path: '/deals/:id/quotations/:quotation',
        components: {
            default: Show,
            modal: EditQuotation
        },
        redirect: '/deals/:id/quotations/:quotation/info',
        meta: { requiresAuth: true },
        children: [
            {
                name: 'deals.show.quotations.info',
                path: '/deals/:id/quotations/:quotation/info',
                components: {
                    tab: InfoQuotation
                },
                meta: { requiresAuth: true }
            },
            {
                name: 'deals.show.quotations.products',
                path: '/deals/:id/quotations/:quotation/products',
                components: {
                    tab: ProductsQuotation
                },
                meta: { requiresAuth: true }
            },
            {
                name: 'deals.show.quotations.charges',
                path: '/deals/:id/quotations/:quotation/charges',
                components: {
                    tab: ChargesQuotation
                },
                meta: { requiresAuth: true }
            },
            {
                name: 'deals.show.quotations.extra',
                path: '/deals/:id/quotations/:quotation/extra',
                components: {
                    tab: AdditionalQuotation
                },
                meta: { requiresAuth: true }
            },
            {
                name: 'deals.show.quotations.payments',
                path: '/deals/:id/quotations/:quotation/payments',
                components: {
                    tab: PaymentQuotation
                },
                meta: { requiresAuth: true }
            }
        ]
    },
    {
        name: 'deals.show.emails.show',
        path: '/deals/:id/emails/:email',
        component: EmailShow,
        meta: { requiresAuth: true }
    }
]



// WEBPACK FOOTER //
// ./src/modules/deals/routes.js